import { useState, useEffect } from "react";
import "../Views/Comingsoon.css";
import PageLayout from "../Components/PageLayout";

function Banner() {
  return (
    <div className="banner" role="img" aria-label="Gold and silver bars banner">
      <div className="banner-overlay" />
      <div className="banner-pattern" aria-hidden="true">
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className="banner-bar-visual">
            <div className="bar-stack">
              <div className="bar-face top" />
              <div className="bar-face front" />
              <div className="bar-face side" />
              <div className="bar-stamp">{i % 2 === 0 ? "999.9" : "999"}</div>
            </div>
          </div>
        ))}
      </div>
      <div className="banner-content">
        <div className="banner-logo">
          <div className="logo-mark" aria-hidden="true">
            <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
              <rect x="2" y="7" width="18" height="10" rx="2.5" fill="rgba(240,232,210,0.15)" stroke="rgba(153,131,77,0.7)" strokeWidth="1" />
              <rect x="5" y="10" width="12" height="4" rx="1.5" fill="rgba(153,131,77,0.25)" />
            </svg>
          </div>
          <span className="logo-text">CoinBazaar</span>
        </div>
        <div className="banner-tagline">Premium Precious Metals</div>
      </div>
    </div>
  );
}

function ProductPill({ metal, purity, color }) {
  return (
    <div className={`product-pill product-pill-${color}`}>
      <span className="pill-dot" aria-hidden="true" />
      <span className="pill-name">{metal}</span>
      <span className="pill-purity">{purity}</span>
    </div>
  );
}

export default function ComingSoon() {
  return (
    <PageLayout page="comingsoon">
      <Banner />

      <section className="content" aria-label="Coming soon announcement">
        <div className="content-inner">
          <div className="eyebrow" aria-hidden="true">
            <span className="eyebrow-line" />
            <span className="eyebrow-text">Premium Gold &amp; Silver Minted Bars </span>
            <span className="eyebrow-line" />
          </div>

          <h1 className="heading">
            Coming <span className="heading-accent">Soon</span>
          </h1>

          <div className="products-row" aria-label="Available products">
            <ProductPill metal="Gold Bars" purity="999.9 Fine" color="gold" />
            <ProductPill metal="Silver Bars" purity="999.9 Fine" color="silver" />
          </div>
        </div>
      </section>
    </PageLayout>
   
  );
}